// @flow
import React from 'react';
import Modal, {
  ModalTransition,
} from '@atlaskit/modal-dialog';
import CrossIcon from '@atlaskit/icon/glyph/cross';

import chronos from 'chronos-assets/images/computer-monitor.png';
import windowsLogo from 'chronos-assets/images/windows-black.svg';
import appleLogo from 'chronos-assets/images/macos-black.svg';
import linuxLogo from 'chronos-assets/images/linux-black.svg';

import {
  Flex,
} from 'chronos-styled';
import * as S from './styled';

type Props = {
  isVisible: boolean,
  setVisibility: { (): void },
  showGuide: { (): void },
};

export default ({
  isVisible,
  setVisibility,
  showGuide,
}: Props) => (
  <ModalTransition>
    {isVisible && (
    <Modal
      onClose={() => setVisibility(false)}
    >
      <S.Content>
        <S.Header>
          <S.Close>
            <div
              onClick={() => {
                setVisibility(false);
              }}
            >
              <CrossIcon
                label="Close Modal"
                size="small"
              />
            </div>
          </S.Close>
        </S.Header>
        <Flex>
          <div>
            <S.MonitorImage
              alt="Chronos Desktop"
              src={chronos}
            />
          </div>
          <S.TextBlock>
            <h2>Desktop Application</h2>
            <p>
            In addition to this web interface, we created a desktop application fully integrated with JIRA.
            It has many features for seamless and simple time-tracking.
            We know you`ll love it!
            </p>
            <S.LinksBlock>
              <S.Link
                rel="noopener noreferrer"
                target="_blank"
                href="https://web-pal.atlassian.net/wiki/display/CHRONOS/About+Chronos+plugin"
              >
                View documentation
              </S.Link>
              <S.InternalLink
                onClick={() => {
                  showGuide();
                }}
              >
                Show tutorial
              </S.InternalLink>
              <S.Link
                rel="noopener noreferrer"
                target="_blank"
                href="https://web-pal.atlassian.net/servicedesk/customer/portal/2"
              >
              Contact us
              </S.Link>
            </S.LinksBlock>
          </S.TextBlock>
        </Flex>
        <S.HorizontalLine />
        <S.Footer>
          <S.Link href="https://chronos-api2.web-pal.com/release/dmg">
            <S.DownloadIcon
              src={appleLogo}
              alt="apple-logo"
            />
            <div>
              Download for OS X
            </div>
          </S.Link>
          <S.Link href="https://chronos-api2.web-pal.com/release/AppImage">
            <S.DownloadIcon
              src={linuxLogo}
              alt="linux-logo"
            />
            <div>
              Download for Linux
            </div>
          </S.Link>
          <S.Link href="https://chronos-api2.web-pal.com/release/exe">
            <S.DownloadIcon
              src={windowsLogo}
              alt="windows-logo"
            />
            <div>
              Download for Windows
            </div>
          </S.Link>
        </S.Footer>
      </S.Content>
    </Modal>
    )}
  </ModalTransition>
);
